module.exports = __webpack_public_path__ + "static/media/investNavLogo.20822dfc.svg";